import script from "./cmtable-selection-tip-bar.vue?vue&type=script&lang=ts&setup=true"
export * from "./cmtable-selection-tip-bar.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__